import { useApolloClient } from "@apollo/client/react";

import { queries } from "@/api";

import { useSession } from "@/contexts/session";
import { useValueListener } from "@jasperlabs/hooks";

const useHasAccountInCache = () => {
	const client = useApolloClient();
	const data = client.readQuery({ query: queries.ME });

	return Boolean(data?.account?.id);
};

const useRefreshCacheOnExternalSignIn = ({ refreshCache, shouldRefresh }) => {
	const { hasAuthenticatedSession } = useSession();
	const hasAccountInCache = useHasAccountInCache();

	useValueListener({
		value: shouldRefresh && hasAuthenticatedSession && !hasAccountInCache,
		onChange({ previous, value }) {
			if (!previous && value) {
				refreshCache();
			}
		},
	});
};

export default useRefreshCacheOnExternalSignIn;
